import { render, staticRenderFns } from "./BlockBooking.vue?vue&type=template&id=51ad007b&"
import script from "./BlockBooking.vue?vue&type=script&lang=js&"
export * from "./BlockBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports